module.exports = __webpack_public_path__ + "img/10.c1a6bb0e.png";